import Enum from './enum'

class AccreditationType extends Enum
{
  constructor(value) {
    super(value);
  }
}

AccreditationType.init({
  OPEN: 'Open',
  CLOSED: 'Closed'
}, {
  OPEN: 'tender-participation-mode.open',
  CLOSED: 'tender-participation-mode.closed'
});

export default AccreditationType;
